import { requestStatusTypes } from "./requestStatusTypes";

export const requestApprovalStatusHasIsDemandOptions = [
  {
    label: "Đang đợi duyệt",
    value: requestStatusTypes.submitted,
  },
  // {
  //   label: "Đang đợi duyệt",
  //   value: requestStatusTypes.preApproved,
  // },
  {
    label: "Đã duyệt",
    value: requestStatusTypes.approved,
  },
  {
    label: "Đang tiếp nhận",
    value: requestStatusTypes.inProgress,
  },
  {
    label: "Đã tiếp nhận",
    value: requestStatusTypes.acceptance,
  },
  {
    label: "Tiến hành thực hiện",
    value: requestStatusTypes.completed,
  },
  {
    label: "Đã bị từ chối",
    value: requestStatusTypes.rejected,
  },
];
